import { render, staticRenderFns } from "./DataSourceCard.vue?vue&type=template&id=52021908&scoped=true"
import script from "./DataSourceCard.vue?vue&type=script&lang=js"
export * from "./DataSourceCard.vue?vue&type=script&lang=js"
import style0 from "./DataSourceCard.vue?vue&type=style&index=0&id=52021908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52021908",
  null
  
)

export default component.exports